export default "__VITE_ASSET__BPcUissE__"